import React from "react";
import PropTypes from "prop-types";
import fields from "../../json/AmenityFields.json";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormTextarea from "Common/Custom/FormTextarea";
import FeaturesManager from "../../Components/FeaturesManager";

const EditAmenityForm = ({
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  imagePreview,
  iconPreview,
  title,
}) => {
  const { formdata } = fields;

  const handleFeaturesChange = (features) => {
    handleChange({ target: { name: "features", value: features } });
  };

  const renderField = (field) => {
    switch (field.type) {
      case "file":
        return (
          <FormInputFile
            key={field.name}
            field={field}
            handleChange={handleFileChange}
            error={errors[field.name]}
            imagePreview={field.name === "image" ? imagePreview : iconPreview}
          />
        );
      case "switch":
        return (
          <Switch
            key={field.name}
            values={values[field.name]}
            handleChange={handleChange}
            field={field}
            ValueOne="1"
            ValueTwo="0"
            LabelOne="Active"
            LabelTwo="Inactive"
          />
        );
      case "textarea":
        return (
          <FormTextarea
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      case "features":
        return (
          <FeaturesManager
            key={field.name}
            features={values[field.name] || []}
            onChange={handleFeaturesChange}
            error={errors[field.name]}

          />
        );
      default:
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
    }
  };

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>{title}</HeadingOne>}>
      {formdata.map(renderField)}
      <FormSubmitButton label="Update" loading={loading} colSize="col-12" align="end" />
    </PageBody>
  );
};

EditAmenityForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFileChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  imagePreview: PropTypes.string,
  iconPreview: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default EditAmenityForm;
